import React from 'react'
import { withRouter } from 'react-router';

import RoundedButton from '../../Buttons/RoundedButton/RoundedButton';

import { ReactComponent as RewardsIcon } from '../../../assets/images/reward.svg';

import './UserRow.scss';

const UserRow = props => props.user ?
	<li className="user-row">
		<div className="w-50 d-flex align-items-center">
			<h6 className="mr-5 mb-0">{props.user.name}
				<br /><span>
					{props.user.type === 'admin' ? 'Amministratore' : props.user.type === 'artist' ? 'Artista' : props.user.type === 'scout' ? 'Talent Scout' : ''}
				</span>
			</h6>
		</div>
		<div className="w-50 d-flex justify-content-end">
			{props.user.type !== 'scout' ?
				<>
					<p className="track-points">
						{props.points || 0}
						{' punti'}
					</p>
					<p className="track-rewards">
						<RewardsIcon />
						{props.rewards ? props.rewards.length : 0}
						{' Rewards'}
					</p>
				</> : 
				<RoundedButton color="primary" className="px-3 ml-4 " onClick={() => props.history.push('/wallet/' + props.user._id)}>Portafoglio</RoundedButton>}
			
				<RoundedButton color="primary" className="px-3 ml-4 " onClick={() => props.history.push('/users/' + props.user._id)}>VISUALIZZA Profilo</RoundedButton>
				
		</div>
	</li>
	: null;

export default withRouter(UserRow);